import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LoggedinService } from '../../../services/login/loggedin.service';
import { NotificationsService } from '../../../services/notifications/notifications.service';
import { SessionHelper } from '../../../shared/services/localstorage';
import { roleID } from '../../../configurations/configuration';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  _notificationsData = [];
  showLoader: boolean = true;
  roleID = roleID;
  @Input() isViewAll;
  @Input() set notificationsData(value: any) {
    this._notificationsData = value;
    console.log(this._notificationsData);
    if(this._notificationsData.length >= 0) {
      this.showLoader = false;
    }
    else {
      this.showLoader = false;
    }
  }
  get notificationsData(): any {
    // other logic
    return this._notificationsData;
  }
  pageSize: number = 10;
  pageNumber: number = 1;
  totalRecords: number;
  user: any;
  role: number;
  filterObj = {};

  constructor(public loggedInService: LoggedinService, private notificationsService: NotificationsService) { }

  ngOnInit() {
    this.showLoader = true;
    console.log(this.notificationsData)
    this.user = SessionHelper.getSession();
    console.log(this.user)
    this.user = SessionHelper.getSession();
    this.role = this.user.role_id;
  }

  pageChanged(pN: number): void {
    this.pageNumber = pN;
  }
}
